export enum ThreadStateEnum {
  Active = 'active',
  Resolved = 'resolved',
}
